import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { ErrorBoundary } from "./components/ErrorBoundary";
import "./i18n"; // Initialize i18n before app renders
import "./index.css";

// Sits outside BrowserRouter deliberately: it is the only cover for a throw in
// the providers or Layout itself, and having no router context here keeps the
// fallback honest about recovering via window.location rather than <Link>.
ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <ErrorBoundary category="Root">
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </ErrorBoundary>
  </React.StrictMode>
);
